<template>
  <v-app>
    <supplier-type-setup
      :dialog="supplierTypeDialog"
      :data="data"
      @update:dialog="supplierTypeDialog = $event"
    />
    <v-container fluid>
      <template v-if="$insertAccess($route.fullPath)">
        <v-form @submit.prevent="submit">
          <v-row>
            <v-col cols="12">
              <v-expansion-panels v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-title
                    color="blue-grey-lighten-4"
                    class="panel-header"
                    ><span>{{
                      isEntryMode ? "Add Supplier" : "Update Supplier"
                    }}</span></v-expansion-panel-title
                  >
                  <v-expansion-panel-text>
                    <v-row class="py-2 no-gutters justify-space-around">
                      <v-col lg="4" md="4" cols="12">
                        <v-text-field
                          label="Company Name"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="company_name.value.value"
                          :error-messages="company_name.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_name.value.value"
                          :error-messages="supplier_name.errorMessage.value"
                          clearable
                        >
                          <template #label>
                            Supplier Name
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_email.value.value"
                          :error-messages="supplier_email.errorMessage.value"
                          clearable
                        >
                          <template #label>
                            Email Address
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_mobile.value.value"
                          :error-messages="supplier_mobile.errorMessage.value"
                          clearable
                        >
                          <template #label>
                            Mobile Number
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col lg="4" md="4" cols="12">
                        <v-autocomplete
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_country_id.value.value"
                          :error-messages="
                            supplier_country_id.errorMessage.value
                          "
                          clearable
                          :items="getInvCountryList"
                          :item-title="(item) => `${item.name}`"
                          autocomplete="off"
                          item-value="id"
                          :menu-props="{ width: 300 }"
                          @update:modelValue="getInvCountryList"
                        >
                          <template #label>
                            Supplier Country
                            <span class="text-red-accent-4">*</span>
                          </template>
                          <template v-slot:selection="{ props, item }">
                              <div class="d-flex align-center noto-color-emoji-regular"
                                  v-bind="props"
                                  color="primary"
                                  variant="tonal"
                              >
                              <span class="mr-1">{{ item.raw.emoji }}</span>
                              {{ item.raw.name }}
                            </div>
                          </template>
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" v-slot=""  :title="null">
                                <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                    <span class="mr-2 text-lg">{{ item.raw.emoji }}</span>
                                    <div class="flex-grow-1">
                                        <span>{{ item.raw.name }}</span>
                                        <small v-if="item.raw.native" class="text-grey">
                                            ({{ item.raw.native }})
                                        </small>
                                    </div>
                                    <div class="text-grey text-caption">
                                        +{{ item.raw.phonecode }}
                                    </div>
                                </div>
                            </v-list-item>
                          </template>
                        </v-autocomplete>

                        <v-autocomplete
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_type_id.value.value"
                          :error-messages="supplier_type_id.errorMessage.value"
                          clearable
                          :items="getSupplierTypeList"
                          :item-title="(item) => `${item.code} - ${item.name}`"
                          autocomplete="off"
                          item-value="id"
                          @update:modelValue="getSupplierTypeList"
                        >
                          <template #label>
                            Supplier Type
                            <span class="text-red-accent-4">*</span>
                          </template>

                          <template v-slot:append-inner>
                            <v-slide-x-reverse-transition mode="out-in">
                              <v-icon
                                @mousedown.stop="openAddSupplierType"
                                icon="mdi-plus-circle-outline"
                                color="primary"
                                size="24"
                                class="cursor-pointer"
                              ></v-icon>
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>

                        <v-text-field
                          label="Supplier Address"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_address.value.value"
                          :error-messages="supplier_address.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <v-text-field
                          label="Remarks"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          clearable
                        ></v-text-field>
                      </v-col>

                      <v-col lg="4" md="4" cols="12">
                        <v-text-field
                          label="BIN No."
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_bin.value.value"
                          :error-messages="supplier_bin.errorMessage.value"
                          clearable
                        >
                          <!-- <template #label>
                            BIN No.
                            <span class="text-red-accent-4">*</span>
                          </template> -->
                        </v-text-field>

                        <v-text-field
                          label="VAT Number"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_vat.value.value"
                          :error-messages="supplier_vat.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <v-text-field
                          label="TIN No."
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="supplier_tin.value.value"
                          :error-messages="supplier_tin.errorMessage.value"
                          clearable
                        ></v-text-field>

                        <input
                          v-model="supplier_id.value.value"
                          type="hidden"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-expansion-panels v-model="contactPersonInfo">
                <v-expansion-panel>
                  <v-expansion-panel-title
                    color="blue-grey-lighten-4"
                    class="panel-header"
                    ><span>{{
                      isEntryMode
                        ? "Add Contact person Information"
                        : "Update Contact person Information"
                    }}</span></v-expansion-panel-title
                  >

                  <v-expansion-panel-text>
                    <v-row
                      v-for="(contact, index) in contacts"
                      :key="index"
                      class="px-2 py-2"
                      align="center"
                      no-gutters
                      dense
                    >
                      <v-col cols="12" sm="4" md="3" class="pr-4 pa-0">
                        <v-text-field
                          v-model="contact.name"
                          label="Name"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(index, 'name', contact.name)
                          "
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                        <v-text-field
                          v-model="contact.mobile"
                          label="Mobile"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(
                              index,
                              'mobile',
                              contact.mobile
                            )
                          "
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                        <v-text-field
                          v-model="contact.email"
                          label="Email"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(index, 'email', contact.email)
                          "
                        />
                      </v-col>

                      <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                        <v-text-field
                          v-model="contact.designation"
                          label="Designation"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(
                              index,
                              'designation',
                              contact.designation
                            )
                          "
                        />
                      </v-col>

                      <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                        <v-text-field
                          v-model="contact.department"
                          label="Department"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          class="ma-0"
                          @blur="
                            validateContactField(
                              index,
                              'department',
                              contact.department
                            )
                          "
                        />
                      </v-col>

                      <v-col sm="4" md="1" class="d-flex justify-center mb-5">
                        <v-btn
                          @click="removeContactRow(index)"
                          variant="tonal"
                          color="primary"
                          v-if="index !== contacts.length - 1"
                        >
                          <v-icon
                            color="red"
                            icon="mdi-delete"
                            size="large"
                          ></v-icon>
                        </v-btn>

                        <v-btn
                          @click="addContactRow"
                          variant="tonal"
                          color="primary"
                          v-else
                        >
                          <v-icon
                            color="info"
                            icon="mdi-plus"
                            size="large"
                          ></v-icon>
                        </v-btn>
                      </v-col>
                      <v-divider
                        v-if="
                          contacts.length > 1 && index !== contacts.length - 1
                        "
                      ></v-divider>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-expansion-panels v-model="bankInfo">
                <v-expansion-panel>
                  <v-expansion-panel-title
                    color="blue-grey-lighten-4"
                    class="panel-header"
                    ><span>{{
                      isEntryMode
                        ? "Add Bank Information"
                        : "Update Bank Information"
                    }}</span></v-expansion-panel-title
                  >

                  <v-expansion-panel-text>
                    <v-row
                      v-for="(info, index) in bank_info"
                      :key="index"
                      class="px-2"
                      no-gutters
                      dense
                    >
                      <v-col class="pr-3" lg="3" md="4" cols="12">
                        <v-text-field
                          v-model="info.bank_name"
                          label="Bank Name"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />
                        <v-text-field
                          v-model="info.account_holder_name"
                          label="Account holder Name"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />
                      </v-col>

                      <v-col class="pr-3" lg="3" md="4" cols="12">
                        <v-text-field
                          v-model="info.ac_number"
                          label="A/C Number"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />
                        <v-text-field
                          v-model="info.branch_name"
                          label="Branch Name"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />
                      </v-col>

                      <v-col class="pr-3" lg="3" md="4" cols="12">
                        <v-text-field
                          v-model="info.routing_number"
                          label="Routing Number"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />
                        <v-text-field
                          v-model="info.swift_code"
                          label="Swift Code"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />
                      </v-col>

                      <v-col lg="3" md="4" cols="12">
                        <v-text-field
                          v-model="info.ifsc_number"
                          label="IFSC Number"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          hide-details
                          class="ma-0 py-2"
                        />

                        <div class="d-flex justify-end pt-2">
                          <v-btn
                            @click="removeBankInfoRow(index)"
                            variant="tonal"
                            color="primary"
                            v-if="index !== bank_info.length - 1"
                          >
                            <v-icon
                              color="red"
                              icon="mdi-delete"
                              size="large"
                            ></v-icon>
                          </v-btn>

                          <v-btn
                            @click="addBankInfo"
                            variant="tonal"
                            color="primary"
                            v-else
                          >
                            <v-icon
                              color="info"
                              icon="mdi-plus"
                              size="large"
                            ></v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-divider></v-divider>
                    </v-row>

                    <v-row class="px-2">
                      <v-col>
                        <v-textarea
                          clear-icon="mdi-close-circle"
                          rows="3"
                          maxlength="500"
                          label="Description"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="py-2"
                          v-model="description.value.value"
                          :error-messages="description.errorMessage.value"
                          clearable
                        ></v-textarea>
                      </v-col>

                      <v-col>
                        <v-row>
                          <v-file-input
                            v-model="selectedImage"
                            label="Supplier Image/Logo"
                            accept="image/*"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            persistent-hint
                            hint="Image must be exactly 120px × 120px"
                            show-size
                            @input="previewImage"
                            @click:clear="clearImage"
                            prepend-icon="mdi-camera"
                            class="ellipsis-filename pl-2 py-7"
                            title="image"
                          >
                          </v-file-input>

                          <div class="px-2 py-3" style="float: right">
                            <v-img
                              :src="preview"
                              cover
                              class="preview-image"
                            ></v-img>
                          </div>
                        </v-row>

                        <v-row>
                          <v-file-input
                            variant="outlined"
                            density="compact"
                            label="Supplier Document Attachment"
                            bg-color="grey-lighten-4"
                            class="px-2 py-2"
                            chips
                            show-size
                            multiple
                          ></v-file-input>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-card-actions class="justify-end mt-4 pa-4">
                      <v-btn
                        color="grey"
                        variant="flat"
                        type="button"
                        @click="submitForm(0)"
                      >
                        DRAFT
                      </v-btn>
      
                      <v-btn
                        color="primary"
                        variant="flat"
                        type="button"
                        @click="submitForm(1)"
                      >
                        POST
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

        </v-form>
      </template>
    </v-container>
  </v-app>
</template>

<script>
import supplierTypeSetup from "@/components/module/inventory/supplierManagement/supplierTypeSetup.vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, reactive } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { fileServerUrl } from "@/store/api";

const DEFAULT_IMAGE = "/src/assets/no_preview.jpeg";

export default {
  components: {
    supplierTypeSetup,
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    contactPersonInfo: [0],
    bankInfo: [0],
    loading: false,
    search: "",
    dialog: false,
    supplierTypeDialog: false,
    isEntryMode: true,
    unitDialog: false,
    data: {},
    preview: "/src/assets/no_preview.jpeg",
    headers: [
      {
        title: "#SL",
        align: "center",
        key: "index",
        width: "7%",
        sortable: false,
      },
      { title: "Code", key: "user_code", align: "left", sortable: false },
      { title: "Name", key: "name", align: "left", sortable: false },
      { title: "Mobile", align: "left", key: "mobile", sortable: true },
      { title: "Email", align: "left", key: "email", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getSupplierTypeList.length == 0) {
      this.loading = true;
      this.$store.dispatch("getSupplierTypeList").then((response) => {
        this.loading = false;
      });
    }

    if (this.$store.getters.getInvCountryList.length == 0) {
      this.loading = true;
      this.$store.dispatch("getInvCountryList").then((response) => {
        this.loading = false;
      });
    }
  },
  computed: {
    getSupplierTypeList() {
      let data = this.$store.getters.getSupplierTypeList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },

    getInvCountryList() {
      let country = this.$store.getters.getInvCountryList;
      if (country.length > 0) {
        return country;
      }
    },

    editingSupplier() {
      return this.$store.getters.getEditingSupplier;
    },
  },
  methods: {
    openAddSupplierType() {
      this.data = {
        id: "",
        name: "",
        code: "",
        remarks: "",
        status: 1,
      };
      this.supplierTypeDialog = true;
    },
    openAddCountry() {
      this.country = {
        id: "",
        name: "",
        timezones: "",
        phonecode: "",
        remarks: "",
      };
    },
    closeDialog() {
      this.dialog = false;
      this.supplierTypeDialog = false;
      this.data = {};
    },
    resetForm() {
      this.data = {};
      this.preview = "/src/assets/no_preview.jpeg";
      this.selectedImage = null;
    },
    previewImage: function (event) {
      this.selectedImage = event.target.files[0];
      const input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      } else {
        this.preview = "/src/assets/no_preview.jpeg";
      }
    },
    clearImage() {
      this.preview = "/src/assets/no_preview.jpeg";
    },
  },

  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        supplier_type_id: yup.number().positive().integer().required().label("Supplier Type Name"),
        supplier_name: yup.string().min(1).max(50).required().trim().label("Supplier Name"),
        supplier_email: yup.string().email().required().trim().label("Email"),
        supplier_tin: yup.string().nullable().min(1).max(50).trim().label("TIN"),
        company_name: yup.string().min(1).max(50).nullable().trim().label("Company Name"),
        supplier_country_id: yup.number().positive().integer().required().label("Supplier Country"),
        supplier_mobile: yup.string().min(8).max(15).required("Mobile Number is required").label("Mobile Number"),
        supplier_vat: yup.string().nullable().min(1).max(15).label("VAT"),
        supplier_address: yup.string().nullable().min(1).max(150).label("Address"),
        description: yup.string().nullable().max(300).label("Description"),
      }),
    });

    const supplier_type_id = useField("supplier_type_id");
    const supplier_name = useField("supplier_name");
    const supplier_email = useField("supplier_email");
    const supplier_tin = useField("supplier_tin");
    const company_name = useField("company_name");
    const supplier_country_id = useField("supplier_country_id");
    const supplier_mobile = useField("supplier_mobile");
    const supplier_vat = useField("supplier_vat");
    const supplier_bin = useField("supplier_bin");
    const supplier_address = useField("supplier_address");
    const description = useField("description");
    const remarks = useField("remarks");
    const status = useField("status");
    const supplier_id = useField("supplier_id");

    const currentStatus = ref("");

    const contacts = ref([
      {
        name: "",
        mobile: "",
        email: "",
        designation: "",
        department: "",
      },
    ]);

    const bank_info = ref([
      {
        bank_name: "",
        account_holder_name: "",
        ac_number: "",
        branch_name: "",
        routing_number: "",
        swift_code: "",
        ifsc_number: "",
      },
    ]);

    const contactErrors = reactive({});
    const errorMessages = ref("");
    const loading = ref("");
    const selectedImage = ref(null);
    const preview = ref(DEFAULT_IMAGE);
    const isEntryMode = ref(true);

    const store = useStore();
    const router = useRouter();

    const addContactRow = () => {
      contacts.value.push({
        name: "",
        mobile: "",
        email: "",
        designation: "",
        department: "",
      });
    };

    const removeContactRow = (index) => {
      if (contacts.value.length > 1) {
        contacts.value.splice(index, 1);
        // Remove validation errors for the removed contact
        delete contactErrors[index];
        // Re-index the errors
        const newErrors = {};
        Object.keys(contactErrors).forEach((key) => {
          const idx = parseInt(key);
          if (idx > index) {
            newErrors[idx - 1] = contactErrors[key];
          } else if (idx < index) {
            newErrors[idx] = contactErrors[key];
          }
        });
        Object.keys(contactErrors).forEach((key) => delete contactErrors[key]);
        Object.assign(contactErrors, newErrors);
      }
    };

    const addBankInfo = () =>
      ref(
        bank_info.value.push({
          bank_name: "",
          account_holder_name: "",
          ac_number: "",
          branch_name: "",
          routing_number: "",
          swift_code: "",
          ifsc_number: "",
        })
      );

    const removeBankInfoRow = (index) => {
      if (bank_info.value.length > 1) {
        bank_info.value.splice(index, 1);
      }
    };

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();                       
    };

    const submit = handleSubmit((values) => {
      // if (!validateAllContacts()) {
      //   toast.error("Please fix contact validation errors before submitting");
      //   return;
      // }

      const contactsData = contacts.value || [];
      const bankInfoData = bank_info.value || [];

      const statusValue = currentStatus.value ? 1 : 0;

      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] !== null && values[key] !== undefined) {
          formData.append(key, values[key]);
        }
      });

      formData.append("contacts", JSON.stringify(contactsData));
      formData.append("bank_info", JSON.stringify(bankInfoData));
      formData.append("status", statusValue);

      if (selectedImage.value) {
        formData.append("image", selectedImage.value);
      }

      for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      loading.value = true;
      store
        .dispatch("saveUpdateSupplier", formData)
        .then((response) => {
          resetForm();
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "supplier-list" });
          }, 2000);
        })
        .catch((error) => {
          loading.value = false;
          console.error("Error:", error);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    });

    return {
      submit,
      submitForm,
      supplier_type_id,
      supplier_name,
      supplier_email,
      supplier_tin,
      company_name,
      supplier_country_id,
      supplier_mobile,
      contacts,
      bank_info,
      addContactRow,
      removeContactRow,
      addBankInfo,
      removeBankInfoRow,
      supplier_vat,
      supplier_bin,
      supplier_address,
      description,
      remarks,
      status,
      errorMessages,
      selectedImage,
      preview,
      isEntryMode,
      supplier_id,
      resetForm,
      loading,
      contactErrors,
    };
  },

  mounted() {
    if (this.$store.getters.getEditingSupplier) {
      this.isEntryMode = false;
      const supplier = this.$store.getters.getEditingSupplier;
      
      this.supplier_id.value.value = supplier.id;
      this.supplier_name.value.value = supplier.supplier_name;
      this.supplier_email.value.value = supplier.supplier_email;
      this.supplier_tin.value.value = supplier.supplier_tin;
      this.company_name.value.value = supplier.company_name;
      this.supplier_country_id.value.value = supplier.supplier_country_id;
      this.supplier_mobile.value.value = supplier.supplier_mobile;
      this.supplier_vat.value.value = supplier.supplier_vat;
      this.supplier_bin.value.value = supplier.supplier_bin;
      this.supplier_address.value.value = supplier.supplier_address;
      this.description.value.value = supplier.description;
      this.remarks.value.value = supplier.remarks;
      this.supplier_type_id.value.value = supplier.supplier_type_id;
      this.status.value.value = supplier.status == 1 ? true : false;
      this.contacts = supplier.contacts || [
            {
            name: "",
            mobile: "",
            email: "",
            designation: "",
            department: "",
            },
        ];
        this.bank_info = supplier.bank_info || [
            {
            bank_name: "",
            account_holder_name: "",
            ac_number: "",
            branch_name: "",
            routing_number: "",
            swift_code: "",
            ifsc_number: "",
            },
        ];
      
      if (supplier.image) {
        this.preview = supplier.image
          ? fileServerUrl + supplier.image
          : "/src/assets/no_preview.png";
      } else {
        this.preview = DEFAULT_IMAGE;
      }
    } else {
      this.supplier_id.value.value = "";
      this.isEntryMode = true;
    }
  },
  beforeUnmount() {
    // Clear the editing customer from Vuex when component is destroyed
    this.$store.commit("clearEditingSupplier");
  },
};
</script>
